import { ActionTypes } from "../constants/Types";

export const forgotPasswordEmail = (email) => {
  return {
    type: ActionTypes.FORGOT_PASSWORD_EMAIL,
    payload: email,
  };
};

export const clearData = () => {
  return {
    type: ActionTypes.CLEAR_DATA,
  };
};

export const verificationEmail = (email) => {
  return {
    type: ActionTypes.VERIFICATION_EMAIL,
    payload: email,
  };
};

export const verificationId = (id) => {
  return {
    type: ActionTypes.VERIFICATION_ID,
    payload: id,
  };
};
